import { Box } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Banner from '../../atoms/Banner/Banner';
import ContentBox from '../../molecules/ContentBox';
import Table from '../../organisms/Table/Table';

const bd = {
  imgSrc: '/images/image/notice@2x.png',
  imgSrcM: '/images/image/noticeM@2x.jpeg',
  title: 'Notice',
  text1: 'We will guide you through major announcements on the BoB website.',
};

export default function NoticeListPage(props) {
  const { noticeList, headerList } = props;

  const navigate = useNavigate();

  const handleClickRow = (r) => {
    navigate('/notice/detail', { state: { data: r } });
  };

  return (
    <Box>
      <Banner bannerData={bd} />
      <ContentBox>
        <Table rows={noticeList} headers={headerList} onClickRow={handleClickRow} />
      </ContentBox>
    </Box>
  );
}
